import { usePlanIsUncancelable as useIsUncancelable } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-uncancelable/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsUncancelable = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isUncancelable } = viewModel;

	return useIsUncancelable({
		isUncancelable,
		onSetViewModel,
	});
};
